import styled from '@emotion/styled';

const UserBlock = styled.div`
  display: block;
  padding: 2px;
  width: 20px;
`;

const AssignedUsersList = ({ users }) => {
  return users.map((user, index) => <UserBlock key={index}>{user}</UserBlock>);
};

export default AssignedUsersList;
